module.exports = __webpack_public_path__ + "static/videoHistoria-07b294787a0913e261101b335ddbe1aa.mp4";